import React from 'react';
import PropTypes from 'prop-types';

import { Consumer as PageConsumer } from '../../../../contexts/PageContext';
import { RESPONSIVE_DESKTOP } from '../../../../contexts/Includes/pageContextHelpers';

import UpcomingEvents from '../../../Events/UpcomingEvents/UpcomingEvents';
import RecommendedGroupsList from '../../../Groups/RecommendedGroupsList/RecommendedGroupsList';
import { componentTypes } from '../../../Includes/componentContentTypes';
import JobSearchFilter from '../../../JobV3/JobSearchFilter/JobSearchFilter';
import Recommendations from '../../../Messages/Recommendations/Recommendations';

import EmployerReviewsBox from '../../../RightRail/EmployerReviewsBox/EmployerReviewsBox';
import JobsBox from '../../../RightRail/JobsBox/JobsBox';
import SponsoredCompanyBox from '../../../RightRail/SponsoredCompanyBox/SponsoredCompanyBox';
import TrendingContentBox from '../../../RightRail/TrendingContentBox/TrendingContentBox';

import CommonCardShell from '../../CommonCardShell/CommonCardShell';
import './RightRailContent.scss';

export default class RightRailContent extends React.PureComponent {
    renderContents = (context) => {
        const { contents } = this.props;

        const renderedContents = contents.map((content) => {
            let component;
            switch (content) {
                case componentTypes.SUGGESTED_JOBS:
                    component = (
                        <JobsBox
                            suggestedJobs={context.userProps.job}
                            openModal={() =>
                                context.modalTrigger('FollowedJobs')
                            }
                        />
                    );
                    break;
                case componentTypes.COMPANY_REVIEWS:
                    component = (
                        <EmployerReviewsBox
                            reviews={
                                context.userProps.companyReview &&
                                context.userProps.companyReview.reviews
                                    ? context.userProps.companyReview.reviews
                                    : null
                            }
                            hasFollowingCompanies={
                                (context.userProps.companyReview &&
                                    context.userProps.companyReview
                                        .hasFollowingCompanies) ||
                                false
                            }
                            toggleJobReviewSurvey={
                                context.toggleJobReviewSurvey
                            }
                            pageProps={context.pageProps}
                            wrapAuth={context.wrapAuth}
                            isLoggedIn={context.isLoggedIn}
                            modalTrigger={context.modalTrigger}
                        />
                    );
                    break;
                case componentTypes.TRENDING_ARTICLES:
                    component = (
                        <TrendingContentBox
                            trendingArticles={context.userProps.article}
                        />
                    );
                    break;
                case componentTypes.JOB_FILTERS:
                    component = (
                        <CommonCardShell>
                            <JobSearchFilter />
                        </CommonCardShell>
                    );
                    break;
                case componentTypes.SPONSORED_COMPANY:
                    if (context.responsive.breakpoint === RESPONSIVE_DESKTOP) {
                        component = (
                            <SponsoredCompanyBox
                                sponsoredCompany={
                                    context.userProps.sponsoredCompany
                                }
                            />
                        );
                    }
                    break;
                case componentTypes.UPCOMING_EVENTS:
                    if (context.responsive.breakpoint === RESPONSIVE_DESKTOP) {
                        component = (
                            <CommonCardShell>
                                <UpcomingEvents
                                    events={context.userProps.event}
                                />
                            </CommonCardShell>
                        );
                    }
                    break;
                case componentTypes.RECOMMENDED_CONNECTIONS:
                    if (context.responsive.breakpoint === RESPONSIVE_DESKTOP) {
                        component = <Recommendations />;
                    }
                    break;
                case componentTypes.RECOMMENDED_GROUPS:
                    if (context.responsive.breakpoint === RESPONSIVE_DESKTOP) {
                        component = (
                            <CommonCardShell>
                                <RecommendedGroupsList />
                            </CommonCardShell>
                        );
                    }
                    break;
                default:
                    component = null;
            }
            return { component };
        });

        return renderedContents.filter((c) => c.component !== null);
    };

    render() {
        return (
            <div className="component-Layout-RightRailGridLayout-RightRailContent">
                <PageConsumer>
                    {(context) => {
                        return this.renderContents(context).map(
                            (component, i) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <React.Fragment key={i}>
                                    {component.component}
                                </React.Fragment>
                            )
                        );
                    }}
                </PageConsumer>
                {this.props.children}
            </div>
        );
    }
}

RightRailContent.propTypes = {
    contents: PropTypes.arrayOf(PropTypes.string),
    children: PropTypes.node,
};

RightRailContent.defaultProps = {
    contents: [],
    children: null,
};
